import { NgModule } from '@angular/core';
import {
  MatCardModule,
  MatButtonModule,
  MatIconModule
} from '@angular/material';

import { IgoPanelModule } from '@ximple/igo2-common';
import {
  IgoMapModule,
  IgoLayerModule,
  IgoFilterModule,
  IgoMetadataModule,
  IgoDownloadModule
} from '@ximple/igo2-geo';

import { AppLayerComponent } from './layer.component';
import { AppLayerRoutingModule } from './layer-routing.module';

@NgModule({
  declarations: [AppLayerComponent],
  imports: [
    AppLayerRoutingModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    IgoPanelModule,
    IgoMapModule,
    IgoLayerModule,
    IgoFilterModule,
    IgoMetadataModule,
    IgoDownloadModule
  ],
  exports: [AppLayerComponent]
})
export class AppLayerModule {}
